import { Injectable } from '@angular/core';
import { SecureApi } from '../../../../core/secure.api';

@Injectable()
export class NpsService {
    url = 'b2c-patients/net-promoter-scores';
    
    constructor(public secureApi: SecureApi) { }

    getAll(filters) {
        let queryParams = filters;
        return this.secureApi.get(this.url + '/index?' + queryParams);
    }
}